export default "__VITE_ASSET__cfae3867__"